import { createContext, useContext } from "react";
import { Flows } from "../../../../util/Types/Folder";
import { CustomColorPalette } from "../types";

export interface FluxObject {
  id: string;
  name: string;
}

export interface AgentsSidebarContextValue {
  isDarkMode: boolean;
  palette: CustomColorPalette;
  activeFlowId?: string;
  activeObjectId?: string;
  onFlowClick: (flow: Flows, folderId: string) => void;
  onObjectClick: (obj: FluxObject) => void;
}

export const AgentsSidebarContext =
  createContext<AgentsSidebarContextValue | null>(null);

export const useAgentsSidebarContext = () => {
  const context = useContext(AgentsSidebarContext);
  if (!context) {
    throw new Error(
      "AgentsSidebar components must be used within AgentsSidebar.Root",
    );
  }
  return context;
};
